"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PiaDogRadio = exports.PiaCatRadio = exports.PiaAnimalRadioInputs = exports.PIAQuoteToolContext = exports.PIAFullOwnerDetails = exports.PIACoverDisplayOptions = exports.PIAAboutPet = exports.PIAAboutOwner = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _defaultAboutPet = require("../../../defaults/quoteTools/defaultAboutPet");
var _defaultCoverDisplayOptions = require("../../../defaults/quoteTools/defaultCoverDisplayOptions");
var _defaultAboutOwner = require("../../../defaults/quoteTools/defaultAboutOwner");
var _defaultQuoteToolContext = require("../../../defaults/quoteTools/defaultQuoteToolContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable max-len */
var ownerEmailInput = _defaultAboutOwner.DefaultAboutOwner.ownerEmailInput,
  ownerMobileInput = _defaultAboutOwner.DefaultAboutOwner.ownerMobileInput,
  basicOwnerFormOrder = _defaultAboutOwner.DefaultAboutOwner.basicOwnerFormOrder;
var PIAQuoteToolContext = exports.PIAQuoteToolContext = {
  layout: _objectSpread(_objectSpread({}, _defaultQuoteToolContext.DefaultQuoteToolContext.layout), {}, {
    main: {
      heading: _objectSpread(_objectSpread({}, _defaultQuoteToolContext.DefaultQuoteToolContext.layout.main.heading), {}, {
        showMandatoryText: true
      })
    }
  })
};
var PIACoverDisplayOptions = exports.PIACoverDisplayOptions = _objectSpread(_objectSpread({}, _defaultCoverDisplayOptions.DefaultCoverDisplayOptions), {}, {
  petSectionHeading: function petSectionHeading(pet) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "petCoverSectionHeading"
    }, pet.species === 'Dog' ? /*#__PURE__*/_react["default"].createElement(_components.Icon, {
      icon: "dog-outline"
    }) : /*#__PURE__*/_react["default"].createElement(_components.Icon, {
      icon: "cat-outline"
    }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("strong", null, pet.petName), /*#__PURE__*/_react["default"].createElement("small", null, pet.species, " / ", pet.breed)));
  },
  disclaimer: null
});
var PIAAboutOwner = exports.PIAAboutOwner = _objectSpread(_objectSpread({}, _defaultAboutOwner.DefaultAboutOwner), {}, {
  showMembershipField: false,
  mandatoryText: 'Mandatory fields',
  showMandatoryText: true,
  emailDisclaimerText: function emailDisclaimerText() {
    return null;
  },
  ownerEmailInput: _objectSpread(_objectSpread({}, ownerEmailInput), {}, {
    label: 'Email (optional)',
    labelTooltip: null,
    placeholder: 'Enter email',
    validation: {
      pattern: _objectSpread({}, ownerEmailInput.validation.pattern)
    }
  }),
  ownerMobileInput: _objectSpread(_objectSpread({}, ownerMobileInput), {}, {
    label: 'Mobile (optional)',
    labelTooltip: null,
    validation: {
      pattern: _objectSpread({}, ownerMobileInput.validation.pattern)
    }
  }),
  basicOwnerFormOrder: [].concat(_toConsumableArray(basicOwnerFormOrder), ['ownerMobileInput'])
});
var PIAFullOwnerDetails = exports.PIAFullOwnerDetails = _objectSpread(_objectSpread({}, _defaultAboutOwner.DefaultAboutOwner), {}, {
  ownerMobileInput: _objectSpread(_objectSpread({}, ownerMobileInput), {}, {
    label: 'Mobile'
  })
});
var PiaDogRadio = exports.PiaDogRadio = _objectSpread(_objectSpread({}, _defaultAboutPet.DefaultDogRadio), {}, {
  icon: undefined
});
var PiaCatRadio = exports.PiaCatRadio = _objectSpread(_objectSpread({}, _defaultAboutPet.DefaultCatRadio), {}, {
  icon: undefined
});
var PiaAnimalRadioInputs = exports.PiaAnimalRadioInputs = [_objectSpread({}, PiaDogRadio), _objectSpread({}, PiaCatRadio)];
var PIAAboutPet = exports.PIAAboutPet = _objectSpread(_objectSpread({}, _defaultAboutPet.DefaultAboutPet), {}, {
  petSpeciesRadios: _objectSpread(_objectSpread({}, _defaultAboutPet.DefaultAboutPet.petSpeciesRadios), {}, {
    radioInputs: PiaAnimalRadioInputs
  })
});